import type { AxiosResponse } from 'axios';

import { baseRoutes, baseUrl } from '@/api/config';
import axiosInstance from '@/api/instance';
import type {
  GeneratedReport, Report, ReportRequestFilters, ReportRow, ReportType,
} from '@/api/routes/reports/types';
import type { ResponseWithPagination } from '@/utils/types';

const BASE_URL = `${baseUrl}${baseRoutes}`;

export const getAllReportTypes = (): Promise<void | AxiosResponse<ReportType []>> => axiosInstance({
  url: 'reports/types',
  method: 'GET',
  baseURL: BASE_URL,
  headers: {
    authorization: true,
  },
});

export const generateReport = <PARAMS, BODY>(type_id: string, params: PARAMS)
    : Promise<void | AxiosResponse<GeneratedReport<BODY>>> => axiosInstance({
    url: 'reports/generate',
    method: 'POST',
    baseURL: BASE_URL,
    headers: {
      authorization: true,
    },
    data: {
      type_id,
      params,
    },
  });

export const generateXLSXReport = <PARAMS, BODY>(data: Pick<Report<PARAMS, BODY>, 'type_id' | 'params' | 'body' | 'sign'>)
    : Promise<void | AxiosResponse<Blob>> => axiosInstance({
    url: 'reports/generate-xlsx',
    method: 'POST',
    responseType: 'blob',
    baseURL: BASE_URL,
    headers: {
      authorization: true,
    },
    data,
  });

export const createReport = <PARAMS, BODY>(id: string, data: Report<PARAMS, BODY>)
    : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
    url: `reports/${id}`,
    method: 'POST',
    baseURL: BASE_URL,
    headers: {
      authorization: true,
    },
    data,
  });

export const getReportNames = (text: string)
    : Promise<void | AxiosResponse<string[]>> => axiosInstance({
  url: 'reports/select/names',
  method: 'POST',
  baseURL: BASE_URL,
  headers: {
    authorization: true,
  },
  data: {
    text,
  },
});

export const getReportList = (data: ReportRequestFilters)
    : Promise<void | AxiosResponse<ResponseWithPagination<ReportRow>>> => axiosInstance({
  url: 'reports/select-list',
  method: 'POST',
  baseURL: BASE_URL,
  headers: {
    authorization: true,
  },
  data,
});

export const changeReportEnabled = (id: string, data: Pick<ReportRow, 'enabled'>)
    : Promise<void | AxiosResponse<ResponseWithPagination<ReportRow>>> => axiosInstance({
  url: `reports/${id}`,
  method: 'PATCH',
  baseURL: BASE_URL,
  headers: {
    authorization: true,
  },
  data,
});

export const getReportById = <PARAMS, BODY>(id: string)
    : Promise<void | AxiosResponse<Report<PARAMS, BODY>>> => axiosInstance({
    url: `reports/${id}`,
    method: 'GET',
    baseURL: BASE_URL,
    headers: {
      authorization: true,
    },
  });
